import { ChevronsUpDown, Eye } from "lucide-react";
import React, { useState } from "react";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
  width: '230px'
};

export default function ErrorLogsDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    setViewLogModalOpen = () => {},
    setViewLogData = () => {},
    setPreviousScrollPosition = () => {},
  } = props;

  const [orderBy, setOrderBy] = useState();

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };


  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th
                onClick={() => {
                  handleOrderChange("timestamp");
                }}
                className={orderBy === "timestamp" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  date <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("category");
                }}
                className={orderBy === "category" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Category <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>Feature</th>
              <th>Environment</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>

                    <td className="pointer">
                      {item?.timestamp}
                    </td>

                    <td className="pointer">
                      {item?.category}
                    </td>

                    <td className="pointer">
                      {item?.feature}
                    </td>

                    <td className="pointer">
                      {item?.environment?.apiType || item?.environment?.extensionVersion}
                    </td>

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns">
                        <button
                          type="button"
                          className="docpro_icon_btn last_btn_tip"
                          onClick={() => {
                            setViewLogModalOpen(true);
                            setViewLogData(item);
                            setPreviousScrollPosition(window.scrollY);
                            window.scrollTo(0, 0);
                          }}
                        >
                          <Eye width={20} height={20} />
                          <span className="docpro_tip">View Logs</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="5">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="5">
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
